import React from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Typography from '@mui/material/Typography';
import { Divider } from '@mui/material';
import InfoItemBox from './InfoItemBox';
import { InfoItemBoxProps } from '../dataObjects/contentTypes';

const content: InfoItemBoxProps[] = [
  {
    title: "What is an Independent Spending Report",
    blocks: [
      {
        type: "paragraph",
        content: [
          {
            type: "text",
            content: "The campaign finance law requires individuals, entities and businesses to file independent spending reports for certain expenditures. There are three types of independent spending reports:"
          }
        ]
      },
      {
        type: "list",
        listType: "bullet",
        items: [
          {
            content: [
              {
                type: "text",
                isBold: true,
                content: "Independent Expenditures"
              },
              {
                type: "text",
                content: ": This report is e-filed when an individual, entity, business or political committee (other than an IEPAC) makes an expenditure to support or oppose a candidate, but without coordinating or consulting with the candidate or the candidate's committee."
              }
            ]
          },
          {
            content: [
              {
                type: "text",
                isBold: true,
                content: "Electioneering Communications(EC)"
              },
              {
                type: "text",
                content: ": This report is e-filed when an individual, entity or business makes an expenditure for a communication that identifies a candidate, but does not expressly advocate for or against a candidate. ECs are only in effect within 90 days of a general election."
              }
            ]
          },
          {
            content: [
              {
                type: "text",
                isBold: true,
                content: "Ballot Question Spending"
              },
              {
                type: "text",
                content: ": This report is e-filed when an individual, entity or business makes an expenditure to support or oppose a state or district ballot question, and the expenditure is not an in-kind contribution to a ballot question committee."
              }
            ]
          }
        ]
      },
      {
        type: "paragraph",
        content: [
          {
            type: "text",
            content: "The report descriptions above do not include all the thresholds and statutory requirements for filing such reports. The descriptions are meant to provide a basic summary of the requirements.",
            isBold: false
          }
        ]
      }
    ]
  },
  {
    title: "Additional Help & Information",
    blocks: [
      {
        type: "list",
        listType: "bullet",
        items: [
          {
            content: [
              {
                type: "text",
                content: "Help Video: "
              },
              {
                type: "link",
                text: "How to register to file an independent spending report",
                url: "https://www.youtube.com/watch?v=6tOQUsTZKag"
              }
            ]
          },
          {
            content: [
              {
                type: "link",
                text: "Memoranda M-14-03",
                url: "https://ocpf2.blob.core.windows.net/pdf/legaldocs/M-14-03.pdf"
              },
              {
                type: "text",
                content: ": \"Reports of Independent Expenditures Made by Individuals or Entities Other than Independent Expenditure PACs.\""
              }
            ]
          },
          {
            content: [
              {
                type: "link",
                text: "Memoranda M-14-02",
                url: "https://ocpf2.blob.core.windows.net/pdf/legaldocs/M-14-02.pdf"
              },
              {
                type: "text",
                content: ": \"Reports of Electioneering Communications.\""
              }
            ]
          },
          {
            content: [
              {
                type: "link",
                text: "Interpretive Bulletin IB-10-01",
                url: "https://ocpf2.blob.core.windows.net/pdf/legaldocs/IB-10-01.pdf"
              },
              {
                type: "text",
                content: ": \"Disclaimers on Independent Expenditures and Electioneering Communications.\""
              }
            ]
          },
          {
            content: [
              {
                type: "link",
                text: "Interpretive Bulletin IB-06-01",
                url: "https://ocpf2.blob.core.windows.net/pdf/legaldocs/IB-06-01.pdf"
              },
              {
                type: "text",
                content: ": \"Express and issue advocacy, independent expenditures, electioneering communications and coordinated communications.\""
              }
            ]
          },
          {
            content: [
              {
                type: "link",
                text: "Interpretive Bulletin IB-90-02",
                url: "https://ocpf2.blob.core.windows.net/pdf/legaldocs/IB-90-02.pdf"
              },
              {
                type: "text",
                content: ": \"Disclosure and reporting of contributions and expenditures related to ballot questions.\""
              }
            ]
          },
          {
            content: [
              {
                type: "link",
                text: "Interpretive Bulletin IB-88-01",
                url: "https://ocpf2.blob.core.windows.net/pdf/legaldocs/IB-88-01.pdf"
              },
              {
                type: "text",
                content: ": \"The applicability of the campaign finance law to groups that do not engage in political fundraising.\""
              }
            ]
          }
        ]
      }
    ]
  }
];



const RegisterInfoIE = (): JSX.Element => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });


  return (
      <div>
        <Typography
              component="h1"
              variant="h4"
              align={'left'}
              data-aos={'fade-up'}
              gutterBottom
              sx={{
                fontWeight: 700,
              }}
              paddingTop={4}>
              Set Up Your Committee with OCPF
            </Typography>

            <Divider />
         
         {content.map((content, index) => (
          <InfoItemBox key={index} {...content} />
        ))}
      </div>
       
   
        
  );
};

export default RegisterInfoIE;
